<template>
  <v-container
    v-resize="onResize"
    class="pa-0 mt-md-2 max-width-sm"
  >
    <v-card
      class="pt-4"
      flat
      tile
      :height="cardHeight"
    >
      <v-sheet
        class="text-center mx-auto sheet-calendar"
        elevation="2"
        width="180"
        style="border-radius: 8px;"
      >
        <div
          class="text-xs-center py-2 deep-orange white--text"
          style="border-top-left-radius: 8px; border-top-right-radius: 8px;"
        >
          {{ $t('eLeave.DaysAvailable') }}
        </div>
        <h2 class="text-h3 mb-0 py-6">
          {{ leaveStat.remainFeriasDays }}
        </h2>
      </v-sheet>

      <div class="pa-4">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <div class="grey--text">
              {{ $t('eLeave.ALDays') }}
            </div>
            <div>
              <div class="py-1">
                {{ $t('eLeave.DaysGetThisYear', [leaveStat.daysGetThisYear]) }}
              </div>
              <div class="py-1">
                {{ $t('eLeave.DaysFromLastYear', [leaveStat.daysFromLastYear]) }}
              </div>
              <div class="py-1">
                {{ $t('eLeave.DaysAntecipatedLastYear', [leaveStat.daysAnteLastYear]) }}
              </div>
              <div
                v-if="leaveStat.daysToNextYearOfficial > 0 || leaveStat.daysToNextYearPersonal > 0"
                class="py-1"
              >
                {{ $t('eLeave.daysToNextYear', [leaveStat.daysToNextYearOfficial + leaveStat.daysToNextYearPersonal]) }}
              </div>
              <!--
            <div class="py-1 pl-4">
              <p
                v-for="(record, index) in leaveStat.listStaffNextYearLeaveStat"
                :key="index"
              >
                {{ $numberToMonth(record.month) }}：{{ record.numDays }}{{ $t('eLeave.Days') }}
              </p>
            </div>
            -->
              <!--
              <div class="py-1 pl-4">
                四月: 1日
              </div>
              <div class="py-1">
                提前享受年假(入職少於一年):
              </div>
              <div class="py-1">
                轉移至下年之年假:
              </div>
              -->
            </div>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <div class="grey--text">
              {{ $t('eLeave.AboutFeriasConsume') }}
            </div>
            <div>
              <div class="py-1">
                {{ $t('eLeave.ConsumedFeriasDaysCount', [leaveStat.approvedFeriasDays]) }}
              </div>
              <div class="py-1">
                {{ $t('eLeave.ConsumedAntecipacaoDaysCount', [nextYearLeaveTotalNumber]) }}
              </div>
              <div class="py-1 pl-4">
                <p
                  v-for="(record, index) in leaveStat.listApprovedNextYearFeriasDays"
                  :key="index"
                >
                  {{ $numberToMonth(record.month - 1) }}：{{ record.numDays }}{{ $t('eLeave.Days') }}
                </p>
              </div>
              <!--
              <div class="py-1 pl-4">
                四月: 1日
              </div>
              <div class="py-1">
                提前享受年假(入職少於一年):
              </div>
              <div class="py-1">
                轉移至下年之年假:
              </div>
              -->
              <div class="py-1">
                {{ $t('eLeave.UsedTenDaysAL') }}：<span v-if="leaveStat.approvedLongFerias">{{ $t('eLeave.CompensateUsed') }}</span><span v-if="!leaveStat.approvedLongFerias">{{ $t('eLeave.CompensateNotUsed') }}</span>
              </div>
              <div
                v-if="entityConfig.minLongLeaveDay && leaveStat.claimNoLongFeriasStatus"
                class="py-1"
              >
                {{ $t('eLeave.noLongFerias') }}：<span>{{ appCodeStatusText(leaveStat.claimNoLongFeriasStatus) }}</span>
              </div>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <div class="grey--text">
              {{ $t('eLeave.AbsenceData') }}
            </div>
            <div>
              <!--
              <div class="py-1">
                不合理缺勤:
              </div>
              <div class="py-1">
                因從事工會活動而缺勤 ( 每月最多一日 ):
              </div>
              <div class="py-1">
                喪失薪俸之缺勤 ( 每月一日且每年最多六日 ):
              </div>
              <div class="py-1">
                無薪缺勤(ETAPM, 125°) (每年最多六日):
              </div>
              -->
              <div class="py-1">
                {{ $t('eLeave.FaltasPorDoencaDaysCount') }}：{{ leaveStat.approvedFaltaDays || 0 }}{{ $t('eLeave.Days') }}
              </div>
              <div
                v-if="leaveStat.approvedFaltaReasonAssistenciaFamiliarDays > 0"
                class="py-1 pl-4"
              >
                {{ $t('eLeave.FaltasPorAssistenciaFamiliarDaysCount') }} ( {{ $t('eLeave.Max15DaysPerYear') }} )：{{ leaveStat.approvedFaltaReasonAssistenciaFamiliarDays || 0 }}{{ $t('eLeave.Days') }}
              </div>
              <div
                v-if="leaveStat.approvedFaltaOutroDoencaDays > 0"
                class="py-1 pl-4"
              >
                {{ $t('eLeave.FaltasPorDoencaOtherDaysCount') }} ：{{ leaveStat.approvedFaltaOutroDoencaDays || 0 }}{{ $t('eLeave.Days') }}
              </div>
              <div
                v-if="leaveStat.approvedFaltaInternamentoDays > 0"
                class="py-1 pl-4"
              >
                {{ $t('eLeave.FaltasPorDoencaInternamentoDaysCount') }} ：{{ leaveStat.approvedFaltaInternamentoDays || 0 }}{{ $t('eLeave.Days') }}
              </div>
              <!--
              <div class="py-1 pl-4">
                因住院而缺勤:
              </div>
              <div class="py-1">
                其他因病缺勤" 3日
              </div>
              -->
            </div>
          </v-col>

          <template>
            <v-col
              cols="12"
              md="6"
            >
              <div class="grey--text">
                {{ $t('eLeave.AccumulatedCompensate') }}
              </div>
              <div v-if="!compensateStat">
                <div class="py-1">
                  {{ $t('PublicServant.NoData') }}
                </div>
              </div>

              <v-expansion-panels
                v-else
                flat
                accordion
              >
                <v-expansion-panel
                  v-for="item in compensateStat"
                  :key="item.id"
                >
                  <v-expansion-panel-header class="pl-0">
                    {{ $t('eLeave.ProposalNo') }}: {{ item.refDocNo }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ $t('eLeave.LastEnjoyDate') }}: {{ item.expiryDate }}<br>
                    {{ $t('eLeave.EffectiveDate') }}: {{ item.effectiveDate }}<br>
                    {{ $t('eLeave.CompensateHours') }}: {{ secondToHourMinute(item.compensateMins) }} / {{ secondToHourMinute(item.consumedMins) }}<br>
                    {{ $t('eLeave.CompensateDays') }}: {{ item.compensateDays ? item.compensateDays : '--' }} / {{ item.consumedDays ? item.consumedDays : '--' }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </template>
        </v-row>

        <br>

        <div class="text-center">
          <v-chip
            v-perServices="[preServices.ELEAVE]"
            color="grey lighten-2"
            class="mr-3 mb-3"
            @click="showProgress"
          >
            {{ $t('Workflow.Progress') }}
          </v-chip>
          <v-chip
            color="grey lighten-2"
            to="/eleave/ApprovedLeaveTable"
            class="mr-3 mb-3"
          >
            {{ $t('eLeave.AllAppliedLeave') }}
          </v-chip>
          <v-chip
            color="grey lighten-2"
            to="/eleave/ApprovedAbsentTable"
            class="mr-3 mb-3"
          >
            {{ $t('eLeave.AllAppliedAbsent') }}
          </v-chip>
          <v-chip
            v-if="$config.isWeb && !$config.isShowMapa"
            color="grey lighten-2"
            :href="hrMapaUrl"
            target="_blank"
            class="mr-3 mb-3"
          >
            {{ $t('eLeave.ALRegistrationData') }}
          </v-chip>

          <v-chip
            v-if="$config.isShowMapa"
            color="grey lighten-2"
            class="mr-3 mb-3"
            to="/mapa/MapaIndex"
          >
            {{ $t('eLeave.ALRegistrationData') }}
          </v-chip>

          <v-chip
            v-perServices="[preServices.SICK_LEAVE]"
            color="grey lighten-2"
            to="/eleave/SickLeaveList"
            class="mb-3"
          >
            {{ $t('eleave.SickForm') }}
          </v-chip>
        </div>
      </div>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="deep-orange"
            rounded
            dark
            fixed
            bottom
            right
            class="elevation-8"
            :style="{ 'z-index': 1, right: fabRight }"
            v-on="on"
          >
            {{ $t('eLeave.ApplyALOrAbsence') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-perServices="[preServices.ELEAVE]"
            to="/eleave/AnnualLeave"
          >
            <v-list-item-title>
              {{ $t('eLeave.ApproveAL') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-perServices="[preServices.ELEAVE]"
            to="/eleave/ReasonableLeave"
          >
            <v-list-item-title>
              {{ $t('eLeave.ApproveAbsence') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-perServices="[preServices.ELEAVE]"
            to="/eleave/TransferLeave"
          >
            <v-list-item-title>
              {{ $t('eLeave.TransferAL') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="entityConfig && entityConfig.minLongLeaveDay > 0"
            v-perServices="[preServices.ELEAVE]"
            to="/eleave/NoLongLeave"
          >
            <v-list-item-title>
              {{ $t('eLeave.noLongFerias') }}
            </v-list-item-title>
          </v-list-item>
          <!-- no need to show it
            <v-list-item
            v-perServices="[preServices.SICK_LEAVE]"
            to="/eleave/SickLeaveList"
          >
            <v-list-item-title>
              {{ $t('eleave.SickForm') }}
            </v-list-item-title>
          </v-list-item>
          -->
          <v-list-item
            v-if="$config.isWeb"
            v-perServices="[preServices.PAPER_LEAVE]"
            :href="hrPaperLeaveUrl"
          >
            <v-list-item-title>
              {{ $t('Workflow.Form.ELeave.StaffPaperApplication') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <br class="hidden-sm-and-up">
      <br class="hidden-sm-and-up">
      <br class="hidden-xs-only">
      <br class="hidden-xs-only">
    </v-card>
  </v-container>
</template>

<script>

import { staffModule, eLeaveModule, codeTableModule } from '../../store/moduleName'
import store from '../../store'
import eLeave from '../../store/modules/leave/eLeave'
import siteIntegrate from '@/api/general/siteIntegrate'
import { mapState, mapGetters } from 'vuex'
import codeTable from '../../store/modules/hr/codeTable'
import { PER_SERVICES } from '@/constant/constant'
import { BUSINESS_CODE } from '../../constant/constant'
import { secondToHourMinute } from '@/utils/datetimeUtil'
// import { parseJwt } from '@/utils/utils'
// import { getStorage } from '@/utils/storageUtil'
// import sickLeaveApi from '@/api/leave/sickLeave'
// import { isArrayEmptyOrNull } from '@/utils/arrayUtil'

if (!store.state[codeTableModule]) store.registerModule(codeTableModule, codeTable)

if (!store.state[eLeaveModule]) store.registerModule(eLeaveModule, eLeave)

export default {
  components: {
  },
  data: function () {
    return {
      fab: false,
      windowSize: {
        x: 0,
        y: 0
      },
      cardHeight: null,
      fabRight: '16px',
      preServices: PER_SERVICES,
      noLongLeaveStatus: null
    }
  },
  computed: {
    hrMapaUrl () {
      return siteIntegrate.getHrMapaUrl()
    },
    hrPaperLeaveUrl () {
      return siteIntegrate.getHrPaperLeaveUrl()
    },
    ...mapState(eLeaveModule, {
      leaveStat: state => state.leaveStat,
      compensateStat: state => state.compensateStat,
      entityConfig: state => state.entityConfig
    }),
    ...mapGetters({
      nextYearLeaveTotalNumber: eLeaveModule + '/countNumDaysOfNextYearLeave'
    })
  },
  mounted () {
    this.onResize()
  },
  created () {
    let currentYear = (new Date()).getFullYear()
    this.$store.dispatch(staffModule + '/getStaff')
    this.$store.dispatch(eLeaveModule + '/getLeaveStat', currentYear)
    this.$store.dispatch(eLeaveModule + '/getCompensateStat', currentYear)
    this.$store.dispatch(eLeaveModule + '/getEntityConfig')
    // this.$store.dispatch(codeTableModule + '/getPubHolidays')
  },
  methods: {
    showProgress () {
      let progressOption = {
        showEndTask: false,
        businessCodes: [BUSINESS_CODE.ELEAVE_FERIAS, BUSINESS_CODE.ELEAVE_FALTA, BUSINESS_CODE.ELEAVE_TRANSFER, BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS, BUSINESS_CODE.LEAVE_MARK],
        backLink: '/eleave/list'
      }
      // this.setProgressOption(progressOption)
      this.$router.push({
        path: '/workflow/List',
        query: progressOption
      })
    },
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.x < 600) {
        this.cardHeight = this.windowSize.y
      } else {
        this.cardHeight = null
      }

      if (this.windowSize.x > 1264) {
        this.fabRight = '20%'
      } else if (this.windowSize.x > 960) {
        this.fabRight = '18%'
      } else {
        this.fabRight = '16px'
      }
    },
    secondToHourMinute (seconds) {
      if (seconds) {
        return secondToHourMinute(seconds, 'xh xm')
      } else {
        return '--'
      }
    },
    appCodeStatusText (code) {
      return this.$t('eLeave.appStatus.' + code)
    }
  }
}
</script>
